module.exports = __webpack_public_path__ + "a8cf47668807d74d63f89a44913fad0a.png";